import { motion } from 'framer-motion';
import { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import CloseShape from '@/components/common/svg/shapes/CloseShape.tsx';
import PhotoShape from '@/components/common/svg/shapes/PhotoShape.tsx';
import {
  buttonStyles,
  buttonTextStyles,
  containerStyles,
  dotLeftBottom,
  dotLeftTop,
  dotRightTop,
  headerTextStyles,
  iconsContainerStyles,
  textStyles
} from '@/components/Discovery/Card/placeholders/styles.ts';
import { routes } from '@/navigation/routes.tsx';

export const InsufficientData = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onClick = () => {
    navigate(routes.profileEdit);
  };

  return (
    <div style={containerStyles}>
      <div
        style={{
          ...iconsContainerStyles,
          width: '94px',
          height: '94px'
        }}
      >
        <PhotoShape
          width={100}
          height={100}
          fillColor="#505050"
          style={{
            marginTop: '-5px',
            marginLeft: '-3px'
          }}
        />

        <div style={secondaryShapeBg}>
          <CloseShape
            width={25}
            height={25}
            fillColor="#2f333d"
            strokeWidth={3}
            style={{
              transform: 'rotate(45deg)'
            }}
          />
        </div>

        <div style={dotLeftBottom} />
        <div style={dotLeftTop} />
        <div style={dotRightTop} />
      </div>

      <h2 style={headerTextStyles}>
        {t('discovery.card.placeholder.insufficient_data.header')}
      </h2>
      <p style={textStyles}>
        {t('discovery.card.placeholder.insufficient_data.text')}
      </p>

      <motion.div
        whileTap={{ scale: 0.9 }}
        onClick={onClick}
        onTap={onClick}
        style={buttonStyles}
      >
        <span style={buttonTextStyles}>
          {t('discovery.card.placeholder.insufficient_data.btn_label')}
        </span>
      </motion.div>
    </div>
  );
};

const secondaryShapeBg: CSSProperties = {
  position: 'absolute',
  width: '30px',
  height: '30px',
  borderRadius: '18px',
  background: '#d9e0ec',
  bottom: '5px',
  left: '33px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};